import { DeserializedServer } from '@amzn/awscat-portfolio-assessment-types';
import { createContext, FC, useState } from 'react';

import { ApplicationWithMappings, DatabaseWithMappings } from '../components/portfolio-mgmt/contact-mgmt/interfaces';

export interface IContactManagementContext {
    applications: ApplicationWithMappings[],
    servers: DeserializedServer[],
    databases: DatabaseWithMappings[],
    updateApplications: (applications: ApplicationWithMappings[]) => void,
    updateServers: (servers: DeserializedServer[]) => void,
    updateDatabases: (database: DatabaseWithMappings[]) => void,
}

export const ContactManagementContext = createContext<IContactManagementContext>({
    applications: [],
    servers: [],
    databases: [],
    updateApplications: () => {},
    updateServers: () => {},
    updateDatabases: () => {}
});

export const ContactManagementProvider: FC = ({ children }) => {
    const [ applications, setApplications ] = useState<ApplicationWithMappings[]>([]);
    const [ servers, setServers ] = useState<DeserializedServer[]>([]);
    const [ databases, setDatabases ] = useState<DatabaseWithMappings[]>([]);

    const updateApplications = (applications: ApplicationWithMappings[]) => {
        setApplications(applications);
    };

    const updateServers = (servers: DeserializedServer[]) => {
        setServers(servers);
    };

    const updateDatabases = (databases: DatabaseWithMappings[]) => {
        setDatabases(databases);
    };

    return (
        <ContactManagementContext.Provider
            value={{
                applications,
                servers,
                databases,
                updateApplications,
                updateServers,
                updateDatabases
            }}
        >
            {children}
        </ContactManagementContext.Provider>
    );
};
